module.exports = __webpack_public_path__ + "static/media/navSecondImg.52c46596.png";